<div class="box shadow">
  <div class="row pt-2 pb-2">
    <div class="col-8 h6">Order ID : {{ orderDetails.orderNumber }}</div>
    <div class="col-4 h5 text-center fw-bold">Rs. {{  getSubtotal() | number }}</div>
  </div>
  <div class="scrollItems">
    @for (foodItem of cartFoods; track foodItem; let i = $index) {
      <div class="swipe-container"
        [class.cart-item-selected]="i === selectedCartIndex"
        (click)="selectedCartIndex = i">
        <div class="order-indicator" [ngClass]="foodItem.id !== undefined ? 'existing-order' : 'new-order'"></div>
        <div class="swipe-content">
          <div class="d-flex">
            <p class="food-quantity my-auto me-3">{{ foodItem.quantity }}</p>
            <div class="food-info">
              <p class="food-name">{{ foodItem.foodId | foodItemName : foodItems }}</p>
              <!--            @if (!isNameContainsSpecialCharacter(foodItem.foodId)) {-->
              <i class="extra-info">{{ foodItem.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</i>
              <!--            }-->
              <div class="d-flex">
                @if (foodItem.id === undefined) {
                  <i class="extra-info my-auto">
                  Rs.{{ foodItem.price | number }}</i>
                } @else {
                  <i
                  class="extra-info my-auto">Rs.{{ foodItem.price / foodItem.quantity | number }}</i>
                }
              </div>
              <p class="kitchen-info d-flex">{{ foodItem.kitchenIntroduction | truncate: 15 }}
                @if ((foodItem.kitchenIntroduction ?? '').length > 15) {
                  <span class="ms-2" [nz-tooltip]="foodItem.kitchenIntroduction">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000000" viewBox="0 0 256 256">
                      <path
                      d="M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z"></path>
                    </svg>
                  </span>
                }
              </p>
            </div>
          </div>
          <div class="d-flex">
            @if (foodItem.id === undefined) {
              <p class="food-quantity my-auto">
              Rs.{{ foodItem.price * foodItem.quantity | number }}</p>
            } @else {
              <p class="food-quantity my-auto">Rs.{{ foodItem.price | number }}</p>
            }
          </div>
        </div>
        <button class="delete-btn" (click)="onDeleteClick($event, foodItem)" nz-tooltip nzTooltipTitle="Delete (Del)">Delete</button>
      </div>
    }


    <!--        <div class="row mb-2 cart-food-item" *ngFor="let foodItem of cartFoods; let i = index" >-->
    <!--          <div class="col-1 delete-btn">-->
    <!--            <a (click)="onDeleteFood(foodItem)">-->
    <!--              <em class="las la-times fs-6"></em>-->
  <!--            </a>-->
<!--          </div>-->
<!--          <div class="col-2">-->
<!--            <div>{{foodItem.quantity}}</div>-->
<!--            <small><i>{{foodItem.foodQuantityTagId! | quantityTagName: foodItemQuantity}}</i></small>-->
<!--          </div>-->
<!--          <div class="col-6">-->
<!--            <div class="h7 text-weight">-->
<!--              &lt;!&ndash; {{foodItem.name}} &ndash;&gt;-->
<!--              {{foodItem.foodId | foodItemName : foodItems }}-->
<!--            </div>-->
<!--            <div>{{foodItem.kitchenIntroduction}}</div>-->
<!--          </div>-->
<!--          <div class="col-3 text-end">-->
<!--            <div *ngIf="foodItem.id === undefined else printed">Rs.{{foodItem.price * foodItem.quantity }}</div>-->
<!--            <ng-template #printed>Rs.{{foodItem.price}}</ng-template>-->
<!--          </div>-->
<!--        </div>-->
</div>

<!-- <div class="row">
<div class="col-9 h6">Total</div>
<div class="col-3 h6 text-end">Rs.{{ getSubtotal() | number }}</div>
</div> -->
<hr>
  <div class="row mb-2 g-1">
    <div class="col-12 col-sm-7">
      <button nzType="primary" nzSize="large" nz-button [disabled]="isOrderPrinted" class="w-100 btn-with-shortcut"
        (click)="onCreateOrder('leave')">
        <span class="btn-text">Create: Leave</span>
      </button>
    </div>
    <div class="col-12 col-sm-5">
      <button nzType="primary" nzSize="large" nz-button nzGhost [disabled]="isOrderPrinted" class="w-100 btn-with-shortcut"
        (click)="onCreateOrder('stay')">
        <span class="btn-text">Create: Stay</span>
        <span class="btn-shortcut">Ctrl+S</span>
      </button>
    </div>

  </div>
  <div class="d-flex mb-2">
    <div class="w-100 pe-1">
      <button nzType="primary" nzSize="large" nz-button class="w-100 btn-with-shortcut"
        (click)="onPrintKot()">
        <span class="btn-text">Print</span>
        <span class="btn-shortcut">Ctrl+P</span>
      </button>
    </div>
    <div class="w-100 ps-1">
      <button nzType="primary" nzSize="large" nzGhost nzDanger nz-button
        class="w-100 btn-with-shortcut"
        (click)="onCloseOrder()">
        <span class="btn-text">Check-out</span>
        <span class="btn-shortcut">Enter ×2</span>
      </button>
    </div>
  </div>
</div>
